import React, { useContext, useEffect, useState } from "react";
import site from '../Images/site.png'
import listen from '../Images/listen.png'
import location from '../Images/location.png'
import state from '../Images/state.png'
import stop from '../Images/stop.png'
import remote from '../Images/remote.png'
import offlineMap from '../Images/offlineMap.png'
import './MainCenter.css'
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";
import { MainContext } from "../store/mainContext";
import cardService from "../services/cardServices";
import utils from "../services/utilsServices";
import AddDevice from './AddDevice'
import SelectDevice from './SelectDevice'
import StopDevice from './StopDevice'
import { useNavigate } from 'react-router-dom';
import ConfirmDialog from './ConfirmDialog'
export default function MainCenter() {
    let navigate = useNavigate();
    const { defaultDevice, setDefaultDevice } = useContext(MainContext);
    const [showSelectDevice, setShowSelectDevice] = useState(false)
    const [showAddDevice, setShowAddDevice] = useState(false)
    const [showStopDevice, setShowStopDevice] = useState(false)

    useEffect(() => {

    }, []);


    const CreateMenuItem = ({ img, caption, to, onClick }) => {
        return (
            <Link
                to={to}
                className="text-decoration-none"
                onClick={e => {
                    if (to)
                        return;
                    e.preventDefault();
                    e.stopPropagation();
                    if (onClick) {
                        const list = cardService.getCard();
                        if (defaultDevice == null && list == []) {
                            toast.warn('ابتدا دستگاه را اضافه کنید', { theme: "colored" });
                            setShowAddDevice(true);
                            return;
                        } else if (defaultDevice == null && list != []) {
                            toast.warn('ابتدا دستگاه را انتخاب کنید', { theme: "colored" });
                            setShowSelectDevice(true);
                            return;
                        }
                        onClick(e)
                    }

                }}>
                <div className="row">
                    <div className="col d-flex justify-content-center">
                        <img src={img} className="imgMainMenuItem" />
                    </div>
                </div>
                <div className="row">
                    <div className="col d-flex justify-content-center">
                        <span className="text-white font1">{caption}</span>
                    </div>
                </div>
            </Link>
        )
    }

    const [showConfirm, setShowConfirm] = useState(false)
    const [noShowAgain, setNoShowAgain] = useState(false)
    const keyNoShowAgain = "NoShowAgain"
    const doLock = () => {
        setShowConfirm(false)
        if (noShowAgain)
            localStorage.setItem(keyNoShowAgain, "true");
        utils.sendSms(defaultDevice.deviceNumber, `loc`);
        toast.success(utils.waitSms);

    }
    return (
        <>
            <ConfirmDialog
                title={<h5>توجه !</h5>}
                show={showConfirm}
                onClose={e => { setShowConfirm(false) }}
                handleDo={doLock}>
                <div className="alert alert-success">
                    پس از دریافت پیامک ، متن پیامک را در منوی نقشه ، در انتهای همین صفحه کپی کنید
                </div>
                <div className="row mt-3">
                    <div className="col">
                        <div className="form-check">
                            <input
                                checked={noShowAgain}
                                onChange={(e) => {
                                    setNoShowAgain(e.target.checked)
                                }}
                                className="form-check-input"
                                type="checkbox"
                                name="mode" />
                            <label
                                className="form-check-label"
                                htmlFor="mode">
                                عدم نمایش مجدد این پیام
                            </label>
                        </div>
                    </div>
                </div>
            </ConfirmDialog>
            {showAddDevice && <AddDevice show={showAddDevice} handleClose={e => { setShowAddDevice(false) }} />}
            {showSelectDevice && <SelectDevice show={showSelectDevice} handleClose={e => { setShowSelectDevice(false) }} />}
            {showStopDevice && <StopDevice show={showStopDevice} handleClose={e => { setShowStopDevice(false) }} />}

            <div className="row align-items-center justify-content-center">
                <div className=" col  d-flex  align-items-center   justify-content-center  "
                    id="mainCenterBody">
                    <div>
                        {defaultDevice &&
                            <>
                                <div className="row  "  >
                                    <div className="col">
                                        <div className="d-flex w-100 justify-content-center fs-4 ">
                                            <span className="me-2 fw-bold text-white">{defaultDevice.deviceName}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row  "  >
                                    <div className="col">
                                        <div className="d-flex w-100 justify-content-center fs-4 ">
                                            <span className="me-2 fw-bold text-white">{defaultDevice.deviceNumber}</span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        <div className="row p-3" id="mainCenterMenuItem" >
                            <div className="col">
                                <div className="row">
                                    <div className="col">
                                        <CreateMenuItem
                                            img={site}
                                            caption="سامانه نورون"
                                            to="https://web.noron1.ir/" />
                                    </div>
                                    <div className="col">
                                        <CreateMenuItem
                                            img={listen}
                                            caption="شنود صدا"
                                            onClick={() => {
                                                const link = document.createElement('a');
                                                let temp = utils.checkNumber(defaultDevice.deviceNumber);
                                                link.href = `tel:+${temp}`;
                                                document.body.appendChild(link);
                                                link.click();
                                            }} />
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col">
                                        <CreateMenuItem
                                            img={location}
                                            caption="موقعیت یابی"
                                            onClick={e => {
                                                const show = localStorage.getItem(keyNoShowAgain);
                                                const noShow = !show || show == "";
                                                setNoShowAgain(!noShow)
                                                if (noShow)
                                                    setShowConfirm(true)
                                                else
                                                    doLock()
                                            }}
                                        />
                                    </div>
                                    <div className="col">
                                        <CreateMenuItem
                                            img={state}
                                            caption="وضعیت خودرو"
                                            onClick={() => {
                                                utils.sendSms(defaultDevice.deviceNumber, `report`);
                                                toast.success(utils.waitSms);
                                            }} />
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col">
                                        <CreateMenuItem
                                            img={stop}
                                            caption="توقف خودرو"
                                            onClick={() => {
                                                setShowStopDevice(true)
                                            }} />
                                    </div>
                                    <div className="col">
                                        <CreateMenuItem
                                            img={remote}
                                            caption="ریموت کنترل"
                                            onClick={(e) => {
                                                navigate('/control');
                                            }} />
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col">
                                        <CreateMenuItem
                                            img={offlineMap}
                                            caption="نقشه"
                                            to="/map"

                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );

}
